import { grpc } from '@improbable-eng/grpc-web';
import { config } from '../env';
import { UserManagerClient } from '../proto/user-manager_pb_service';
import {
  AddUserReq,
  EditUserReq,
  GetUserInfoReq,
  HasQueuedEditEmailReq,
  SubscribeToBetaReq,
  UpdateEmailReq,
  UpdatePasswordReq
} from '../proto/user-manager_pb';
import { AccountManagerClient } from '../proto/account-manager_pb_service';
import {
  AccountListReq,
  AddAccountReq,
  AutoMapSymbolsReq,
  ChangeAccountEnvReq,
  CloseAccountsTradesReq,
  CompareSymbolsReq,
  DeleteAccountReq,
  EnableAccountReq,
  EnableAccountSymbolReq,
  EnableAllAccountSymbolsReq,
  GetAccountInfoReq,
  GetEPSettingsReq,
  GroupListReq,
  GetUsersDedicatedEnvListReq,
  ListAccountSymbolsReq,
  ListCopiedTradesReq,
  MappedSymbolListReq,
  SymbolStatsReq,
  UnmappedSymbolListReq,
  UpdateAccountReq,
  UpsertEPSettingsReq,
  CheckAvailableEnvReq,
  UpdateDedicatedEnvReq,
  GetAllowedCTraderAccountsReq,
  SaveCTraderAuthInfoReq,
  GetCTraderAuthenticatedProfileListReq,
  UpdateCTraderAuthInfoReq,
  CTraderInfoReq,
  GetDxtUsersAccountListReq,
  DxtInfoReq,
  TradeLockerInfoReq,
  GetTradeLockerUsersAccountListReq,
  TimelyReset,
  GetMatchTraderUsersAccountListReq,
  MatchTreaderInfoReq,
  OpenTradeWarningReq,
  ActivateBetaConnectionReq,
  ActivateAnalyzerReq,
  SymbolLotOverrideReq,
  DeleteSymbolLotOverrideReq,
  SaveTradovateAuthInfoReq,
  GetTradovateProfileListReq,
  UpdateTradovateAuthInfoReq,
  GetTradovateUserAccountListReq,
  TradovateInfoReq,
  DeleteCTraderAuthInfoReq,
  DeleteTradovateAuthInfoReq
} from '../proto/account-manager_pb';
import { TradeCopierClient } from '../proto/trade-copier_pb_service';
import {
  AddConfigReq,
  AddCopierTemplateReq,
  AddSlavesReq,
  AddSymbolMappingReq,
  AssociatedMasterSymbolReq,
  CopyExistingTradeReq,
  DeleteConfigReq,
  DeleteCopierTemplateReq,
  DeleteSalvesReq,
  DeleteSymbolMappingReq,
  DeleteSymbolSettingsReq,
  EditSymbolMappingReq,
  GetUserConfigsReq,
  ListCopierTemplateReq,
  ListSymbolMappingsReq,
  ListSymbolSettingsReq,
  MappingReq,
  PauseAccountReq,
  PauseAccountSymbolReq,
  TradingHour,
  UpdateConfigReq,
  UpdateCopierTemplateReq,
  UpdatedSlaveConfig,
  UpdateSlaveManyReq,
  UpdateSlaveReq,
  UpdateSymbolSettingsReq
} from '../proto/trade-copier_pb';
import { BoolValue, DoubleValue, Int32Value, Int64Value, StringValue } from 'google-protobuf/google/protobuf/wrappers_pb';
import { BrokerManagerClient } from '../proto/broker-manager_pb_service';
import { GetBrokerInfoReq, GetServerInfoReq, ListBrokersReq } from '../proto/broker-manager_pb';
import { BillingManagerClient } from '../proto/billing-manager_pb_service';
import {
  BillingOverviewReq,
  CancelSubscriptionImmediatelyReq,
  CancelSubscriptionReq,
  CardSetUpIntentReq,
  CreateCryptoPaymentRequest,
  CreateSubscriptionReq,
  DeleteCardReq,
  GetDownloadableInvoiceReq,
  GetOverDueInfoReq,
  GetUpcomingInvoiceReq,
  ListCardsReq,
  ListInvoicesReq,
  ListPricesReq,
  ListSubscriptionsReq,
  ModifySubscriptionReq,
  ReactivateSubscriptionReq,
  RenewOverDueSubscriptionReq,
  SetDefaultPaymentMethodReq
} from '../proto/billing-manager_pb';
import { AnalyticsManagerClient } from '../proto/analytics-manager_pb_service';
import {
  AccountsOverviewStatsReq,
  AccountStatsReq,
  CopierMetricsReq,
  GetBalanceInfoReq,
  ListAccountStatsReq,
  ListTradesReq,
  OverviewStatsReq
} from '../proto/analytics-manager_pb';
import { NewsManagerClient } from '../proto/news-manager_pb_service';
import {
  CalendarEventListReq,
  CreateCalendarEventAlertReply,
  CreateCalendarEventAlertReq,
  DeleteCalendarEventAlertReply,
  DeleteCalendarEventAlertReq,
  ListMyAlertsReply,
  ListMyAlertsReq,
  MarketNewsListReq,
  ToggleNewsBookmarkReply,
  ToggleNewsBookmarkReq
} from '../proto/news-manager_pb';
import { NotificationManagerClient } from '../proto/notification-manager_pb_service';
import {
  AccountMeta,
  BlockNotificationReq,
  ConfigDetailsReq,
  DisableNotificationReq,
  EditConfigReq,
  EnableNotificationReq,
  GetNotificationReq,
  GetNotificationsReq,
  InstallIntegrationReq,
  IntegrationStatusReq,
  NotificationConfig,
  OverrideNotificationReq,
  UnblockNotificationReq
} from '../proto/notification-manager_pb';
import { Timestamp } from 'google-protobuf/google/protobuf/timestamp_pb';
import { StatusManagerClient } from '../proto/status_manager_pb_service';
import { StatusReq } from 'proto/status_manager_pb';
import { risk_type_display_map } from 'sections/trade-copier/CopyTradingTableSection';
import { SentimentAnalyzerClient } from 'proto/sentiment-analyzer_pb_service';
import { GetBrokersSymbolSentimentReq, GetSymbolsReq, GetSymbolsSentimentReq, SentimentOverviewReq } from 'proto/sentiment-analyzer_pb';
import { AnalyzerClient } from 'proto/analyzer_pb_service';
import {
  GetAccountTradeListRequest,
  ListAccountsReq,
  ListAccountsLiteReq,
  GetPerformanceOverviewReq,
  GetAccountPerformanceRequest,
  GetPortfolioOverviewReq,
  GetPortfolioEquityCurveReq,
  GetPortfolioDailyAndCumulativeROIReq,
  GetUserTagsReq,
  CreateUserTagReq,
  DeleteUserTagReq,
  SetTradeTagReq,
  UpdateUserTagReq
} from 'proto/analyzer_pb';
import { DateRange } from 'proto/common/common_pb';

let __userClient: UserManagerClient;
let __accountClient: AccountManagerClient;
let __tradeManagerClient: TradeCopierClient;
let __brokerManagerClient: BrokerManagerClient;
let __billingClient: BillingManagerClient;
let __analyticsManagerClient: AnalyticsManagerClient;
let __newsManagerClient: NewsManagerClient;
let __notificationClient: NotificationManagerClient;
let __statusManagerClient: StatusManagerClient;
let __sentimentClient: SentimentAnalyzerClient;
let __analyzerClient: AnalyzerClient;

const gatewayAddress = config.envoy_hostname;

export class UserClient {
  meta: grpc.Metadata.HeaderObject = {};
  constructor() {
    this.meta = {};
  }
  setMeta(key: string, value: string | string[]) {
    this.meta[key] = value;
  }
  getClient = () => {
    if (__userClient != null) {
      return __userClient;
    }
    __userClient = new UserManagerClient(gatewayAddress);
    return __userClient;
  };

  addUser = (user: AddUserReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new AddUserReq();
      req.setFirstName(user.firstName);
      req.setLastName(user.lastName);
      req.setEmail(user.email);
      req.setAddress(user.address);
      req.setBio(user.bio);
      req.setCountry(user.country);
      req.setPhone(user.phone);
      req.setTimezone(user.timezone);

      const client = this.getClient();
      client.addUser(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  editUser = (user: EditUserReq.AsObject) => {
    return new Promise((resolve, reject) => {
      console.log('UserClient.editUser calling with:', user);
      let req = new EditUserReq();
      req.setFirstName(user.firstName);
      req.setLastName(user.lastName);
      // req.setEmail(user.email);
      req.setAddress(user.address);
      req.setBio(user.bio);
      req.setCountry(user.country);
      req.setPhone(user.phone);
      req.setUserId(user.userId);
      req.setCurrency(user.currency);
      req.setTimezone(user.timezone);

      const client = this.getClient();
      client.editUser(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  updateEmail = (user: UpdateEmailReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new UpdateEmailReq();
      req.setEmail(user.email);
      req.setUserId(user.userId);

      const client = this.getClient();
      client.updateEmail(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  hasQueuedEditEmail = (user: HasQueuedEditEmailReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new HasQueuedEditEmailReq();
      req.setUserId(user.userId);

      const client = this.getClient();
      client.hasQueuedEditEmail(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  getUserInfo = (getUserReq: GetUserInfoReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new GetUserInfoReq();
      req.setUserId(getUserReq.userId);

      const client = this.getClient();
      client.getUserInfo(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  updatePassword = (updateReq: UpdatePasswordReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new UpdatePasswordReq();
      req.setUserId(updateReq.userId);
      req.setNewPassword(updateReq.newPassword);

      const client = this.getClient();
      client.updatePassword(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  subscribeToBeta = (betaReq: SubscribeToBetaReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new SubscribeToBetaReq();
      req.setUserId(betaReq.userId);
      req.setSubscribe(betaReq.subscribe);

      const client = this.getClient();
      client.subscribeToBeta(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };
}

export class AccountClient {
  meta: grpc.Metadata.HeaderObject = {};
  constructor() {
    this.meta = {};
  }
  setMeta(key: string, value: string | string[]) {
    this.meta[key] = value;
  }
  getClient = () => {
    if (__accountClient != null) {
      return __accountClient;
    }
    __accountClient = new AccountManagerClient(gatewayAddress);
    return __accountClient;
  };

  addAccount = (accountReq: AddAccountReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new AddAccountReq();
      req.setAccountNumber(accountReq.accountNumber);
      req.setHost(accountReq.host);
      req.setPort(accountReq.port);
      req.setUserId(accountReq.userId);
      req.setPassword(accountReq.password);
      req.setNickname(accountReq.nickname);
      req.setPlatform(accountReq.platform);
      req.setBrokerId(accountReq.brokerId);
      req.setServerId(accountReq.serverId);
      req.setPriority(accountReq.priority);
      if (accountReq?.dxtInfo) {
        req.setDxtInfo(this.fromDxtInfo(accountReq?.dxtInfo));
      }
      if (accountReq.ctraderInfo) {
        req.setCtraderInfo(this.fromCTraderReqInfo(accountReq.ctraderInfo));
      }
      if (accountReq.tradeLockerInfo) {
        req.setTradeLockerInfo(this.fromTradeLockerReqInfo(accountReq.tradeLockerInfo));
      }
      if (accountReq.matchTraderInfo) {
        req.setMatchTraderInfo(this.fromMTRReqInfo(accountReq.matchTraderInfo));
      }
      if (accountReq.tradovateInfo) {
        req.setTradovateInfo(this.fromTVReqInfo(accountReq.tradovateInfo));
      }
      req.setDedicatedEnvId(this.fromStingValueWithNull(accountReq.dedicatedEnvId));

      const client = this.getClient();
      client.addAccount(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  getDxtUsersAccountList = (accountReq: GetDxtUsersAccountListReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new GetDxtUsersAccountListReq();
      req.setUserId(accountReq.userId);
      req.setHost(accountReq.host);
      req.setUsername(accountReq.username);
      req.setPassword(accountReq.password);

      const client = this.getClient();
      client.getDxtUsersAccountList(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  getTradeLockerUsersAccountList = (accountReq: GetTradeLockerUsersAccountListReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new GetTradeLockerUsersAccountListReq();
      req.setUserId(accountReq.userId);
      req.setEmail(accountReq.email);
      req.setServerName(accountReq.serverName);
      req.setIsDemo(accountReq.isDemo);
      req.setPassword(accountReq.password);

      const client = this.getClient();
      client.getTradeLockerUsersAccountList(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  getMatchTraderUsersAccountList = (accountReq: GetMatchTraderUsersAccountListReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new GetMatchTraderUsersAccountListReq();
      req.setUserId(accountReq.userId);
      req.setEmail(accountReq.email);
      req.setPassword(accountReq.password);
      req.setHost(accountReq.host);
      req.setBrokerId(accountReq.brokerId);

      const client = this.getClient();
      client.getMatchTraderUsersAccountList(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  updateAccount = (accountReq: UpdateAccountReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new UpdateAccountReq();
      req.setAccountId(accountReq.accountId);
      req.setUserId(accountReq.userId);
      if (accountReq.nickname) {
        req.setNickname(accountReq.nickname);
      }
      if (accountReq.password) {
        req.setPassword(this.fromStingValue(accountReq.password));
      }
      if (accountReq.considerOnPortfolio?.value !== undefined) {
        req.setConsiderOnPortfolio(this.fromBoolValue(accountReq.considerOnPortfolio) as any);
      }
      if (accountReq.activatePremium?.value !== undefined) {
        req.setActivatePremium(this.fromBoolValue(accountReq.activatePremium) as any);
      }

      const client = this.getClient();
      client.updateAccount(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  getAccountList = (accountListReq: AccountListReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new AccountListReq();
      req.setUserId(accountListReq.userId);
      req.setPageSize(accountListReq.pageSize);
      req.setPaginationCursor(accountListReq.paginationCursor);
      req.setSearchPattern(accountListReq.searchPattern);

      const client = this.getClient();
      client.getAccountList(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  getAccountInfo = (accountInfoReq: GetAccountInfoReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new GetAccountInfoReq();
      req.setUserId(accountInfoReq.userId);
      req.setAccountId(accountInfoReq.accountId);

      const client = this.getClient();
      client.getAccountInfo(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  deleteAccount = (deleteAccountReq: DeleteAccountReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new DeleteAccountReq();
      req.setUserId(deleteAccountReq.userId);
      req.setAccountId(deleteAccountReq.accountId);

      const client = this.getClient();
      client.deleteAccount(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  enableAccount = (enableAccReq: EnableAccountReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new EnableAccountReq();
      req.setUserId(enableAccReq.userId);
      req.setAccountId(enableAccReq.accountId);
      req.setEnable(this.fromBoolValue(enableAccReq.enable));
      req.setPriority(enableAccReq.priority);

      const client = this.getClient();
      client.enableAccount(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  openTradeWarning = (enableAccReq: OpenTradeWarningReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new OpenTradeWarningReq();
      req.setUserId(enableAccReq.userId);
      req.setAccountId(enableAccReq.accountId);
      req.setIsConfig(enableAccReq.isConfig);
      req.setSlaveIdsList(enableAccReq.slaveIdsList);

      const client = this.getClient();
      client.openTradeWarning(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  activateBetaConnection = (activateBetaReq: ActivateBetaConnectionReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new ActivateBetaConnectionReq();
      req.setUserId(activateBetaReq.userId);
      req.setAccountId(activateBetaReq.accountId);
      req.setActivateBeta(activateBetaReq.activateBeta);

      const client = this.getClient();
      client.activateBetaConnection(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  activateAnalyzer = (activateReq: ActivateAnalyzerReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new ActivateAnalyzerReq();
      req.setUserId(activateReq.userId);
      req.setAccountId(activateReq.accountId);
      if (activateReq.activate) {
        const boolValue = new BoolValue();
        boolValue.setValue(activateReq.activate.value);
        req.setActivate(boolValue);
      }

      const client = this.getClient();
      client.activateAnalyzer(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  listAccountSymbols = (symbolsReq: ListAccountSymbolsReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new ListAccountSymbolsReq();
      req.setUserId(symbolsReq.userId);
      req.setAccountId(symbolsReq.accountId);
      req.setQuery(symbolsReq.query);
      req.setPageSize(symbolsReq.pageSize);
      req.setPaginationCursor(symbolsReq.paginationCursor);

      const client = this.getClient();
      client.listAccountSymbols(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  enableAccountSymbol = (enableReq: EnableAccountSymbolReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new EnableAccountSymbolReq();
      req.setUserId(enableReq.userId);
      req.setAccountId(enableReq.accountId);
      req.setSymbolId(enableReq.symbolId);
      req.setEnable(enableReq.enable);

      const client = this.getClient();
      client.enableAccountSymbol(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  enableAllAccountSymbols = (enableReq: EnableAllAccountSymbolsReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new EnableAllAccountSymbolsReq();
      req.setUserId(enableReq.userId);
      req.setAccountId(enableReq.accountId);
      req.setEnable(enableReq.enable);

      const client = this.getClient();
      client.enableAllAccountSymbols(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  listCopiedTrades = (copiedTrades: ListCopiedTradesReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new ListCopiedTradesReq();
      req.setUserId(copiedTrades.userId);
      req.setPageSize(copiedTrades.pageSize);
      req.setPaginationCursor(copiedTrades.paginationCursor);
      req.setSearchTicket(this.fromStingValueWithNull(copiedTrades.searchTicket as any));

      const client = this.getClient();
      client.listCopiedTrades(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  compareSymbol = (symbolReq: CompareSymbolsReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new CompareSymbolsReq();
      req.setUserId(symbolReq.userId);
      req.setMasterAccount(symbolReq.masterAccount);
      req.setSlaveAccount(symbolReq.slaveAccount);
      // req.setShowEmpty(symbolReq.showEmpty);

      const client = this.getClient();
      client.compareSymbols(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  getEPSettings = (epReq: GetEPSettingsReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new GetEPSettingsReq();
      req.setUserId(epReq.userId);
      req.setAccountId(epReq.accountId);

      const client = this.getClient();
      client.getEPSettings(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  upsertEPSettings = (epReq: any) => {
    return new Promise((resolve, reject) => {
      let req = new UpsertEPSettingsReq();
      req.setUserId(epReq.userId);
      req.setAccountId(epReq.accountId);

      if (epReq.configurationStyle !== null && epReq.configurationStyle !== undefined) {
        req.setConfigurationStyle(this.fromStingValue(epReq.configurationStyle));
      }

      if (epReq.timelyResetSetting !== null && epReq.timelyResetSetting !== undefined) {
        req.setTimelyResetSetting(this.fromTimelyResetSetting(epReq.timelyResetSetting));
      }

      if (epReq.enableEp !== null && epReq.enableEp !== undefined) {
        req.setEnableEp(this.fromBoolValue(epReq.enableEp));
      }

      if (epReq.manageExisting !== null && epReq.manageExisting !== undefined) {
        req.setManageExisting(this.fromBoolValue(epReq.manageExisting));
      }

      if (epReq.closeAllOpenTrades !== null && epReq.closeAllOpenTrades !== undefined) {
        req.setCloseAllOpenTrades(this.fromBoolValue(epReq.closeAllOpenTrades));
      }

      if (epReq.closeCopiedOpenTrades !== null && epReq.closeCopiedOpenTrades !== undefined) {
        req.setCloseCopiedOpenTrades(this.fromBoolValue(epReq.closeCopiedOpenTrades));
      }

      // if (epReq.disableCopier !== null && epReq.disableCopier !== undefined) {
      //   req.setDisableCopier(this.fromBoolValue(epReq.disableCopier));
      // }

      if (epReq.absoluteMaximum !== null && epReq.absoluteMaximum !== undefined) {
        req.setAbsoluteMaximum(this.fromDoubleValue(epReq.absoluteMaximum));
      }

      if (epReq.absoluteMinimum !== null && epReq.absoluteMinimum !== undefined) {
        req.setAbsoluteMinimum(this.fromDoubleValue(epReq.absoluteMinimum));
      }

      if (epReq.drawDownDifferenceValue !== null && epReq.drawDownDifferenceValue !== undefined) {
        req.setDrawDownDifferenceValue(this.fromDoubleValue(epReq.drawDownDifferenceValue));
      }

      if (epReq.drawDownPercentage !== null && epReq.drawDownPercentage !== undefined) {
        req.setDrawDownPercentage(this.fromDoubleValue(epReq.drawDownPercentage));
      }

      if (epReq.profitDifferenceValue !== null && epReq.profitDifferenceValue !== undefined) {
        req.setProfitDifferenceValue(this.fromDoubleValue(epReq.profitDifferenceValue));
      }

      if (epReq.profitPercentage !== null && epReq.profitPercentage !== undefined) {
        req.setProfitPercentage(this.fromDoubleValue(epReq.profitPercentage));
      }

      const client = this.getClient();
      client.upsertEPSettings(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  closeAccountsTrades = (epReq: CloseAccountsTradesReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new CloseAccountsTradesReq();
      req.setUserId(epReq.userId);
      req.setAccountId(epReq.accountId);

      const client = this.getClient();
      client.closeAccountsTrades(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  symbolStats = (symReq: SymbolStatsReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new SymbolStatsReq();
      req.setUserId(symReq.userId);
      req.setMasterAccount(symReq.masterAccount);
      req.setSlaveAccount(symReq.slaveAccount);
      req.setSlaveId(symReq.slaveId);

      const client = this.getClient();
      client.symbolStats(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  symbolLotOverride = (symReq: SymbolLotOverrideReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new SymbolLotOverrideReq();
      req.setUserId(symReq.userId);
      req.setAccountId(symReq.accountId);
      req.setSymbolIdsList(symReq.symbolIdsList);
      req.setMinLots(this.fromDoubleValue(symReq.minLots));
      req.setMaxLots(this.fromDoubleValue(symReq.maxLots));

      const client = this.getClient();
      client.symbolLotOverride(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  deleteSymbolLotOverride = (symReq: DeleteSymbolLotOverrideReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new DeleteSymbolLotOverrideReq();
      req.setUserId(symReq.userId);
      req.setAccountId(symReq.accountId);
      req.setSymbolIdsList(symReq.symbolIdsList);

      const client = this.getClient();
      client.deleteSymbolLotOverride(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  unmappedSymbolList = (symbolsReq: UnmappedSymbolListReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new UnmappedSymbolListReq();
      req.setUserId(symbolsReq.userId);
      req.setPageSize(symbolsReq.pageSize);
      req.setPaginationCursor(symbolsReq.paginationCursor);
      req.setMasterAccount(symbolsReq.masterAccount);
      req.setSlaveId(symbolsReq.slaveId);
      req.setGroup(symbolsReq.group);
      req.setQuery(symbolsReq.query);

      const client = this.getClient();
      client.unmappedSymbolList(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  mappedSymbolList = (symbolsReq: MappedSymbolListReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new MappedSymbolListReq();
      req.setUserId(symbolsReq.userId);
      req.setPageSize(symbolsReq.pageSize);
      req.setPaginationCursor(symbolsReq.paginationCursor);
      req.setMasterAccount(symbolsReq.masterAccount);
      req.setSlaveId(symbolsReq.slaveId);
      req.setGroup(symbolsReq.group);
      req.setQuery(symbolsReq.query);

      const client = this.getClient();
      client.mappedSymbolList(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  autoMapSymbols = (mapReq: AutoMapSymbolsReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new AutoMapSymbolsReq();
      req.setUserId(mapReq.userId);
      req.setMasterAccount(mapReq.masterAccount);
      req.setSlaveAccount(mapReq.slaveAccount);
      req.setSlaveId(mapReq.slaveId);
      req.setPattern(mapReq.pattern);
      req.setOverwriteExisting(mapReq.overwriteExisting);

      const client = this.getClient();
      client.autoMapSymbols(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  groupList = (mapReq: GroupListReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new GroupListReq();
      req.setUserId(mapReq.userId);
      req.setAccountsList(mapReq.accountsList);

      const client = this.getClient();
      client.groupList(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  getUsersDedicatedEnvList = (dediReq: GetUsersDedicatedEnvListReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new GetUsersDedicatedEnvListReq();
      req.setUserId(dediReq.userId);

      const client = this.getClient();
      client.getUsersDedicatedEnvList(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  changeAccountEnv = (dediReq: ChangeAccountEnvReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new ChangeAccountEnvReq();
      req.setUserId(dediReq.userId);
      req.setDedicatedEnvId(this.fromStingValueWithNull(dediReq.dedicatedEnvId));
      req.setAccountId(dediReq.accountId);

      const client = this.getClient();
      client.changeAccountEnv(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  updateDedicatedEnv = (dediReq: UpdateDedicatedEnvReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new UpdateDedicatedEnvReq();
      req.setUserId(dediReq.userId);
      req.setDedicatedEnvId(dediReq.dedicatedEnvId);
      req.setNickName(dediReq.nickName);

      const client = this.getClient();
      client.updateDedicatedEnv(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  checkAvailableEnv = (dediReq: CheckAvailableEnvReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new CheckAvailableEnvReq();
      req.setUserId(dediReq.userId);

      const client = this.getClient();
      client.checkAvailableEnv(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  getAllowedCTraderAccounts = (allowedReq: GetAllowedCTraderAccountsReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new GetAllowedCTraderAccountsReq();
      req.setUserId(allowedReq.userId);
      req.setAuthId(allowedReq.authId);

      const client = this.getClient();
      client.getAllowedCTraderAccounts(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  getTradovateUserAccountList = (allowedReq: GetTradovateUserAccountListReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new GetTradovateUserAccountListReq();
      req.setUserId(allowedReq.userId);
      req.setAuthId(allowedReq.authId);

      const client = this.getClient();
      client.getTradovateUserAccountList(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  getCTraderAuthenticatedProfileList = (allowedReq: GetCTraderAuthenticatedProfileListReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new GetCTraderAuthenticatedProfileListReq();
      req.setUserId(allowedReq.userId);

      const client = this.getClient();
      client.getCTraderAuthenticatedProfileList(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  getTradovateProfileList = (allowedReq: GetTradovateProfileListReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new GetTradovateProfileListReq();
      req.setUserId(allowedReq.userId);

      const client = this.getClient();
      client.getTradovateProfileList(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  updateCTraderAuthInfo = (allowedReq: UpdateCTraderAuthInfoReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new UpdateCTraderAuthInfoReq();
      req.setUserId(allowedReq.userId);
      req.setAuthId(allowedReq.authId);
      req.setNickname(this.fromStingValue(allowedReq.nickname));

      const client = this.getClient();
      client.updateCTraderAuthInfo(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  deleteCTraderAuthInfo = (allowedReq: DeleteCTraderAuthInfoReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new DeleteCTraderAuthInfoReq();
      req.setUserId(allowedReq.userId);
      req.setAuthId(allowedReq.authId);

      const client = this.getClient();
      client.deleteCTraderAuthInfo(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  updateTradovateAuthInfo = (allowedReq: UpdateTradovateAuthInfoReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new UpdateTradovateAuthInfoReq();
      req.setUserId(allowedReq.userId);
      req.setAuthId(allowedReq.authId);
      req.setNickname(this.fromStingValue(allowedReq.nickname));

      const client = this.getClient();
      client.updateTradovateAuthInfo(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  deleteTradovateAuthInfo = (allowedReq: DeleteTradovateAuthInfoReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new DeleteTradovateAuthInfoReq();
      req.setUserId(allowedReq.userId);
      req.setAuthId(allowedReq.authId);

      const client = this.getClient();
      client.deleteTradovateAuthInfo(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  saveCTraderAuthInfo = (allowedReq: SaveCTraderAuthInfoReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new SaveCTraderAuthInfoReq();
      req.setUserId(allowedReq.userId);
      req.setAuthorizationCode(allowedReq.authorizationCode);
      req.setRedirectUrl(allowedReq.redirectUrl);

      const client = this.getClient();
      client.saveCTraderAuthInfo(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  saveTVAuthInfo = (allowedReq: SaveTradovateAuthInfoReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new SaveTradovateAuthInfoReq();
      req.setUserId(allowedReq.userId);
      req.setAuthorizationCode(allowedReq.authorizationCode);
      req.setRedirectUrl(allowedReq.redirectUrl);
      req.setIsDemo(allowedReq.isDemo);

      const client = this.getClient();
      client.saveTradovateAuthInfo(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  fromTimelyResetSetting = (s: TimelyReset.AsObject | undefined): TimelyReset => {
    if (s === null || s === undefined) {
      return null as any;
    }
    let timelyReset = new TimelyReset();
    if (s.drawdownResetPercent !== null && s.drawdownResetPercent !== undefined) {
      timelyReset.setDrawdownResetPercent(this.fromDoubleValue(s.drawdownResetPercent));
    }
    if (s.profitResetPercent !== null && s.profitResetPercent !== undefined) {
      timelyReset.setProfitResetPercent(this.fromDoubleValue(s.profitResetPercent));
    }
    if (s.resetClockTime !== null && s.resetClockTime !== undefined) {
      timelyReset.setResetClockTime(this.fromInt64Value(s.resetClockTime));
    }
    return timelyReset;
  };

  fromInt64Value = (s: Int64Value.AsObject | undefined): Int64Value => {
    if (s === null || s === undefined) {
      return null as any;
    }
    let intVal = new Int64Value();
    intVal.setValue(s.value);
    return intVal;
  };

  fromStingValue = (s: StringValue.AsObject | undefined): StringValue => {
    if (s === null || s === undefined) {
      return null as any;
    }
    let stringValue = new StringValue();
    stringValue.setValue(s.value);
    return stringValue;
  };

  fromStingValueWithNull = (s: StringValue.AsObject | undefined): StringValue => {
    if (s === null || s === undefined || s.value === '') {
      return null as any;
    }
    let stringValue = new StringValue();
    stringValue.setValue(s.value);
    return stringValue;
  };

  fromBoolValue = (s: BoolValue.AsObject | undefined): BoolValue => {
    if (s === null || s === undefined) {
      return null as any;
    }
    let boolValue = new BoolValue();
    boolValue.setValue(s.value);
    return boolValue;
  };

  fromCTraderReqInfo = (s: CTraderInfoReq.AsObject | undefined): CTraderInfoReq => {
    if (s === null || s === undefined) {
      return null as any;
    }
    let info = new CTraderInfoReq();
    info.setAuthId(s.authId);
    return info;
  };

  fromTradeLockerReqInfo = (s: TradeLockerInfoReq.AsObject | undefined): TradeLockerInfoReq => {
    if (s === null || s === undefined) {
      return null as any;
    }
    let info = new TradeLockerInfoReq();
    info.setEmail(s.email);
    info.setIsLive(s.isLive);
    info.setBetaUser(s.betaUser);
    return info;
  };

  fromMTRReqInfo = (s: MatchTreaderInfoReq.AsObject | undefined): MatchTreaderInfoReq => {
    if (s === null || s === undefined) {
      return null as any;
    }
    let info = new MatchTreaderInfoReq();
    info.setEmail(s.email);
    info.setBrokerId(s.brokerId);
    return info;
  };

  fromTVReqInfo = (s: TradovateInfoReq.AsObject | undefined): TradovateInfoReq => {
    if (s === null || s === undefined) {
      return null as any;
    }
    let info = new TradovateInfoReq();
    info.setAuthId(s.authId);
    info.setIsDemo(s.isDemo);
    return info;
  };

  fromDxtInfo = (s: DxtInfoReq.AsObject | undefined): DxtInfoReq => {
    if (s === null || s === undefined) {
      return null as any;
    }
    let info = new DxtInfoReq();
    info.setUsername(s.username);
    return info;
  };

  fromDoubleValue = (s: DoubleValue.AsObject | undefined): DoubleValue => {
    if (s === null || s === undefined) {
      return null as any;
    }
    let doubleValue = new DoubleValue();
    doubleValue.setValue(s.value);
    return doubleValue;
  };
}

export class TradeClient {
  meta: grpc.Metadata.HeaderObject = {};

  constructor() {
    this.meta = {};
  }

  setMeta(key: string, value: string | string[]) {
    this.meta[key] = value;
  }

  getClient = () => {
    if (__tradeManagerClient != null) {
      return __tradeManagerClient;
    }
    __tradeManagerClient = new TradeCopierClient(gatewayAddress);
    return __tradeManagerClient;
  };

  getUserConfigs = (userConfigReq: GetUserConfigsReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new GetUserConfigsReq();
      req.setUserId(userConfigReq.userId);

      const client = this.getClient();
      client.getUserConfigs(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  addConfig = (addConfigReq: AddConfigReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new AddConfigReq();
      req.setMasterAccount(addConfigReq.masterAccount);
      req.setUserId(addConfigReq.userId);

      const client = this.getClient();
      client.addConfig(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  addSlave = (addSlaveReq: AddSlavesReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new AddSlavesReq();
      req.setUserId(addSlaveReq.userId);
      req.setConfigId(addSlaveReq.configId);
      req.setSlaveAccountsList(addSlaveReq.slaveAccountsList);

      const client = this.getClient();
      client.addSlaves(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  updateSlave = (updateSlaveReq: UpdateSlaveReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new UpdateSlaveReq();
      req.setConfigId(updateSlaveReq.configId);
      req.setUserId(updateSlaveReq.userId);
      req.setBalanceMultiplierValue(this.fromInt32Value(updateSlaveReq.balanceMultiplierValue as any));
      req.setEnable(this.fromBoolValue(updateSlaveReq.enable as any));
      req.setCopyPendingOrders(this.fromBoolValue(updateSlaveReq.copyPendingOrders as any));
      req.setCopyStopLoss(this.fromBoolValue(updateSlaveReq.copyStopLoss as any));
      req.setCopyTakeProfit(this.fromBoolValue(updateSlaveReq.copyTakeProfit as any));
      req.setReverseTrade(this.fromBoolValue(updateSlaveReq.reverseTrade as any));
      req.setFixedLotValue(this.fromInt32Value(updateSlaveReq.fixedLotValue as any));
      req.setLotMultiplierValue(this.fromInt32Value(updateSlaveReq.lotMultiplierValue as any));
      req.setRiskType(updateSlaveReq.riskType);
      req.setSlaveId(updateSlaveReq.slaveId);
      req.setForceMinimumLotSize(this.fromBoolValue(updateSlaveReq.forceMinimumLotSize as any));
      req.setForceMaximumLotSize(this.fromBoolValue(updateSlaveReq.forceMaximumLotSize as any));
      req.setCopyComment(this.fromBoolValue(updateSlaveReq.copyComment as any));
      req.setCustomComment(this.fromStringValue(updateSlaveReq.customComment as any));
      req.setStrictClose(this.fromBoolValue(updateSlaveReq.strictClose as any));
      req.setConsiderContractSize(this.fromBoolValue(updateSlaveReq.considerContractSize as any));
      req.setCopyMagicNumber(this.fromBoolValue(updateSlaveReq.copyMagicNumber as any));
      req.setMagicNumber(this.fromInt64Value(updateSlaveReq.magicNumber as any));
      req.setManageExisting(this.fromBoolValue(updateSlaveReq.manageExisting as any));
      req.setManageExisting(this.fromBoolValue(updateSlaveReq.manageExisting as any));
      req.setFixedBalanceMultiplierValue(this.fromInt32Value(updateSlaveReq.fixedBalanceMultiplierValue as any));
      req.setFixedMasterBalance(this.fromInt32Value(updateSlaveReq.fixedMasterBalance as any));
      req.setLotRefinerValue(this.fromInt32Value(updateSlaveReq.lotRefinerValue as any));
      req.setMinDelayTime(this.fromInt64Value(updateSlaveReq.minDelayTime as any));
      req.setMaxDelayTime(this.fromInt64Value(updateSlaveReq.maxDelayTime as any));
      req.setMagicFiltersList(this.fromInt64ValueArr(updateSlaveReq.magicFiltersList));
      req.setCopyExpiryTime(this.fromBoolValue(updateSlaveReq.copyExpiryTime as any));
      req.setCommentFiltersList(this.fromStringValueArr(updateSlaveReq.commentFiltersList));
      req.setMinLotFilter(this.fromInt64Value(updateSlaveReq.minLotFilter as any));
      req.setMaxLotFilter(this.fromInt64Value(updateSlaveReq.maxLotFilter as any));
      req.setStopLossPip(this.fromDoubleValue(updateSlaveReq.stopLossPip as any));
      req.setTakeProfitPip(this.fromDoubleValue(updateSlaveReq.takeProfitPip as any));
      req.setSlRefiner(this.fromDoubleValue(updateSlaveReq.slRefiner as any));
      req.setTpRefiner(this.fromDoubleValue(updateSlaveReq.tpRefiner as any));
      req.setBalancePercentageValue(this.fromDoubleValue(updateSlaveReq.balancePercentageValue as any));
      req.setCopyExistingTrades(this.fromBoolValue(updateSlaveReq.copyExistingTrades as any));
      req.setAllowedTradeSide(this.fromStringValueNull(updateSlaveReq.allowedTradeSide));
      req.setTradingHoursList(this.fromTradingHourList(updateSlaveReq.tradingHoursList));
      req.setMagicFilterType(updateSlaveReq.magicFilterType);
      req.setCommentFilterType(updateSlaveReq.commentFilterType);
      req.setCustomPlacedType(this.fromStringValue({ value: 'byexpert' }));

      const client = this.getClient();
      client.updateSlave(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  overrideSymbolSettings = (updateSlaveReq: UpdateSymbolSettingsReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new UpdateSymbolSettingsReq();
      req.setUserId(updateSlaveReq.userId);
      req.setMasterSymbolName(updateSlaveReq.masterSymbolName);
      req.setSlaveSymbolName(updateSlaveReq.slaveSymbolName);
      req.setBalanceMultiplierValue(this.fromInt32Value(updateSlaveReq.balanceMultiplierValue as any));
      req.setEnable(this.fromBoolValue(updateSlaveReq.enable as any));
      req.setCopyPendingOrders(this.fromBoolValue(updateSlaveReq.copyPendingOrders as any));
      req.setCopyStopLoss(this.fromBoolValue(updateSlaveReq.copyStopLoss as any));
      req.setCopyTakeProfit(this.fromBoolValue(updateSlaveReq.copyTakeProfit as any));
      req.setReverseTrade(this.fromBoolValue(updateSlaveReq.reverseTrade as any));
      req.setFixedLotValue(this.fromInt32Value(updateSlaveReq.fixedLotValue as any));
      req.setLotMultiplierValue(this.fromInt32Value(updateSlaveReq.lotMultiplierValue as any));
      req.setRiskType(updateSlaveReq.riskType);
      req.setSlaveId(updateSlaveReq.slaveId);
      req.setForceMinimumLotSize(this.fromBoolValue(updateSlaveReq.forceMinimumLotSize as any));
      req.setForceMaximumLotSize(this.fromBoolValue(updateSlaveReq.forceMaximumLotSize as any));
      req.setCopyComment(this.fromBoolValue(updateSlaveReq.copyComment as any));
      req.setCustomComment(this.fromStringValue(updateSlaveReq.customComment as any));
      req.setStrictClose(this.fromBoolValue(updateSlaveReq.strictClose as any));
      req.setConsiderContractSize(this.fromBoolValue(updateSlaveReq.considerContractSize as any));
      req.setCopyMagicNumber(this.fromBoolValue(updateSlaveReq.copyMagicNumber as any));
      req.setMagicNumber(this.fromInt64Value(updateSlaveReq.magicNumber as any));
      req.setManageExisting(this.fromBoolValue(updateSlaveReq.manageExisting as any));
      req.setManageExisting(this.fromBoolValue(updateSlaveReq.manageExisting as any));
      req.setFixedBalanceMultiplierValue(this.fromInt32Value(updateSlaveReq.fixedBalanceMultiplierValue as any));
      req.setFixedMasterBalance(this.fromInt32Value(updateSlaveReq.fixedMasterBalance as any));
      req.setLotRefinerValue(this.fromInt32Value(updateSlaveReq.lotRefinerValue as any));
      req.setMinDelayTime(this.fromInt64Value(updateSlaveReq.minDelayTime as any));
      req.setMaxDelayTime(this.fromInt64Value(updateSlaveReq.maxDelayTime as any));
      req.setMagicFiltersList(this.fromInt64ValueArr(updateSlaveReq.magicFiltersList));
      req.setCopyExpiryTime(this.fromBoolValue(updateSlaveReq.copyExpiryTime as any));
      req.setCommentFiltersList(this.fromStringValueArr(updateSlaveReq.commentFiltersList));
      req.setMinLotFilter(this.fromInt64Value(updateSlaveReq.minLotFilter as any));
      req.setMaxLotFilter(this.fromInt64Value(updateSlaveReq.maxLotFilter as any));
      req.setStopLossPip(this.fromDoubleValue(updateSlaveReq.stopLossPip as any));
      req.setTakeProfitPip(this.fromDoubleValue(updateSlaveReq.takeProfitPip as any));
      req.setSlRefiner(this.fromDoubleValue(updateSlaveReq.slRefiner as any));
      req.setTpRefiner(this.fromDoubleValue(updateSlaveReq.tpRefiner as any));
      req.setBalancePercentageValue(this.fromDoubleValue(updateSlaveReq.balancePercentageValue as any));
      // req.setCopyExistingTrades(this.fromBoolValue(updateSlaveReq.copyExistingTrades as any));
      req.setAllowedTradeSide(this.fromStringValueNull(updateSlaveReq.allowedTradeSide));
      // req.setTradingHoursList(this.fromTradingHourList(updateSlaveReq.tradingHoursList));
      req.setMagicFilterType(updateSlaveReq.magicFilterType);
      req.setCommentFilterType(updateSlaveReq.commentFilterType);
      req.setCustomPlacedType(this.fromStringValue({ value: 'byexpert' }));

      const client = this.getClient();
      client.updateSymbolSettings(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  associatedMasterSymbol = (symbolReq: AssociatedMasterSymbolReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new AssociatedMasterSymbolReq();
      req.setUserId(symbolReq.userId);
      req.setSlaveId(symbolReq.slaveId);
      req.setSlaveSymbol(symbolReq.slaveSymbol);

      const client = this.getClient();
      client.associatedMasterSymbol(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  deleteSymbolSettings = (symbolReq: DeleteSymbolSettingsReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new DeleteSymbolSettingsReq();
      req.setUserId(symbolReq.userId);
      req.setSlaveId(symbolReq.slaveId);
      req.setMappingId(symbolReq.mappingId);

      const client = this.getClient();
      client.deleteSymbolSettings(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  copyExistingTrade = (updateSlaveReq: CopyExistingTradeReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new CopyExistingTradeReq();
      req.setUserId(updateSlaveReq.userId);
      req.setMasterAccountId(updateSlaveReq.masterAccountId);
      req.setSlaveId(updateSlaveReq.slaveId);

      const client = this.getClient();
      client.copyExistingTrade(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  updateSlaveMany = (updateSlaveReq: UpdateSlaveManyReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new UpdateSlaveManyReq();
      req.setConfigId(updateSlaveReq.configId);
      req.setUserId(updateSlaveReq.userId);
      req.setUpdatedSlaveConfigsList(this.fromUpdatedSlaveConfigsList(updateSlaveReq.updatedSlaveConfigsList));

      const client = this.getClient();
      client.updateSlaveMany(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  fromUpdatedSlaveConfigsList = (updatedSlaveConfigsList: UpdatedSlaveConfig.AsObject[]) => {
    const list: UpdatedSlaveConfig[] = [];
    for (const updateSlaveReq of updatedSlaveConfigsList) {
      const req = new UpdatedSlaveConfig();
      req.setId(updateSlaveReq.id);
      req.setBalanceMultiplierValue(this.fromInt32Value(updateSlaveReq.balanceMultiplierValue as any));
      req.setEnable(this.fromBoolValue(updateSlaveReq.enable as any));
      req.setCopyPendingOrders(this.fromBoolValue(updateSlaveReq.copyPendingOrders as any));
      req.setCopyStopLoss(this.fromBoolValue(updateSlaveReq.copyStopLoss as any));
      req.setCopyTakeProfit(this.fromBoolValue(updateSlaveReq.copyTakeProfit as any));
      req.setReverseTrade(this.fromBoolValue(updateSlaveReq.reverseTrade as any));
      req.setFixedLotValue(this.fromInt32Value(updateSlaveReq.fixedLotValue as any));
      req.setLotMultiplierValue(this.fromInt32Value(updateSlaveReq.lotMultiplierValue as any));
      req.setRiskType(updateSlaveReq.riskType);
      req.setForceMinimumLotSize(this.fromBoolValue(updateSlaveReq.forceMinimumLotSize as any));
      req.setForceMaximumLotSize(this.fromBoolValue(updateSlaveReq.forceMaximumLotSize as any));
      req.setCopyComment(this.fromBoolValue(updateSlaveReq.copyComment as any));
      req.setCustomComment(this.fromStringValue(updateSlaveReq.customComment as any));
      req.setStrictClose(this.fromBoolValue(updateSlaveReq.strictClose as any));
      req.setConsiderContractSize(this.fromBoolValue(updateSlaveReq.considerContractSize as any));
      req.setCopyMagicNumber(this.fromBoolValue(updateSlaveReq.copyMagicNumber as any));
      req.setMagicNumber(this.fromInt64Value(updateSlaveReq.magicNumber as any));
      req.setManageExisting(this.fromBoolValue(updateSlaveReq.manageExisting as any));
      req.setFixedBalanceMultiplierValue(this.fromInt32Value(updateSlaveReq.fixedBalanceMultiplierValue as any));
      req.setFixedMasterBalance(this.fromInt32Value(updateSlaveReq.fixedMasterBalance as any));
      req.setLotRefinerValue(this.fromInt32Value(updateSlaveReq.lotRefinerValue as any));
      req.setMinDelayTime(this.fromInt64Value(updateSlaveReq.minDelayTime as any));
      req.setMaxDelayTime(this.fromInt64Value(updateSlaveReq.maxDelayTime as any));
      req.setMagicFiltersList(this.fromInt64ValueArr(updateSlaveReq.magicFiltersList));
      req.setCopyExpiryTime(this.fromBoolValue(updateSlaveReq.copyExpiryTime as any));
      req.setCommentFiltersList(this.fromStringValueArr(updateSlaveReq.commentFiltersList));
      req.setMinLotFilter(this.fromInt64Value(updateSlaveReq.minLotFilter as any));
      req.setMaxLotFilter(this.fromInt64Value(updateSlaveReq.maxLotFilter as any));
      req.setStopLossPip(this.fromDoubleValue(updateSlaveReq.stopLossPip as any));
      req.setTakeProfitPip(this.fromDoubleValue(updateSlaveReq.takeProfitPip as any));
      req.setSlRefiner(this.fromDoubleValue(updateSlaveReq.slRefiner as any));
      req.setTpRefiner(this.fromDoubleValue(updateSlaveReq.tpRefiner as any));
      req.setBalancePercentageValue(this.fromDoubleValue(updateSlaveReq.balancePercentageValue as any));
      req.setAllowedTradeSide(this.fromStringValueNull(updateSlaveReq.allowedTradeSide));
      req.setMagicFilterType(updateSlaveReq.magicFilterType);
      req.setCommentFilterType(updateSlaveReq.commentFilterType);
      req.setCustomPlacedType(this.fromStringValue({ value: 'byexpert' }));
      list.push(req);
    }

    return list;
  };

  fromDoubleValue = (s: DoubleValue.AsObject | undefined): DoubleValue => {
    if (s === null || s === undefined) {
      return null as any;
    }
    let doubleValue = new DoubleValue();
    doubleValue.setValue(s.value);
    return doubleValue;
  };

  deleteConfig = (deleteConfigReq: DeleteConfigReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new DeleteConfigReq();
      req.setUserId(deleteConfigReq.userId);
      req.setConfigId(deleteConfigReq.configId);

      const client = this.getClient();
      client.deleteConfig(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  updateConfig = (updateConfigReq: UpdateConfigReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new UpdateConfigReq();
      req.setUserId(updateConfigReq.userId);
      req.setConfigId(updateConfigReq.configId);
      req.setMasterAccountId(updateConfigReq.masterAccountId);
      req.setEnable(this.fromBoolValue(updateConfigReq.enable));
      req.setManageExisting(this.fromBoolValue(updateConfigReq.manageExisting));

      const client = this.getClient();
      client.updateConfig(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  deleteSlave = (deleteSlaveReq: DeleteSalvesReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new DeleteSalvesReq();
      req.setUserId(deleteSlaveReq.userId);
      req.setConfigId(deleteSlaveReq.configId);
      req.setSlaveAccountsList(deleteSlaveReq.slaveAccountsList);

      const client = this.getClient();
      client.deleteSlaves(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  addSymbolMapping = (addSymbolReq: AddSymbolMappingReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new AddSymbolMappingReq();
      req.setUserId(addSymbolReq.userId);
      // req.setMaster(addSymbolReq.master);
      req.setSlaveId(addSymbolReq.slaveId);
      req.setMappingsList(this.fromMappingList(addSymbolReq.mappingsList));
      // req.setName(addSymbolReq.name);

      const client = this.getClient();
      client.addSymbolMapping(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  listSymbolMappings = (symbolReq: ListSymbolMappingsReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new ListSymbolMappingsReq();
      req.setUserId(symbolReq.userId);
      req.setSlaveId(symbolReq.slaveId);

      const client = this.getClient();
      client.listSymbolMappings(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  deleteSymbolMapping = (deleteReq: DeleteSymbolMappingReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new DeleteSymbolMappingReq();
      req.setUserId(deleteReq.userId);
      req.setSlaveId(deleteReq.slaveId);
      req.setSymbolId(deleteReq.symbolId);
      req.setDeleteAll(deleteReq.deleteAll);

      const client = this.getClient();
      client.deleteSymbolMapping(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  editSymbolMapping = (editReq: EditSymbolMappingReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new EditSymbolMappingReq();
      req.setUserId(editReq.userId);
      req.setSlaveId(editReq.slaveId);
      req.setSymbolId(editReq.symbolId);
      req.setName(editReq.name);

      const client = this.getClient();
      client.editSymbolMapping(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  listSymbolSettings = (symbolReq: ListSymbolSettingsReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new ListSymbolSettingsReq();
      req.setUserId(symbolReq.userId);
      req.setSlaveId(symbolReq.slaveId);

      const client = this.getClient();
      client.listSymbolSettings(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  pauseAccountSymbol = (pauseReq: PauseAccountSymbolReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new PauseAccountSymbolReq();
      req.setUserId(pauseReq.userId);
      req.setSlaveId(pauseReq.slaveId);
      req.setMasterSymbol(pauseReq.masterSymbol);
      req.setSlaveSymbol(pauseReq.slaveSymbol);
      if (pauseReq.pauseUntil && pauseReq.pauseUntil.seconds > 0) {
        req.setPauseUntil(this.fromTimestamp(pauseReq.pauseUntil));
      }

      const client = this.getClient();
      client.pauseAccountSymbol(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  listCopierTemplate = (pauseReq: ListCopierTemplateReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new ListCopierTemplateReq();
      req.setUserId(pauseReq.userId);

      const client = this.getClient();
      client.listCopierTemplate(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  deleteCopierTemplate = (templateReq: DeleteCopierTemplateReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new DeleteCopierTemplateReq();
      req.setUserId(templateReq.userId);
      req.setId(templateReq.id);

      const client = this.getClient();
      client.deleteCopierTemplate(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  updateCopierTemplate = (addReq: UpdateCopierTemplateReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new UpdateCopierTemplateReq();
      req.setUserId(addReq.userId);
      req.setId(addReq.id);
      req.setName(addReq.name);
      req.setBalanceMultiplierValue(this.fromInt32Value(addReq.balanceMultiplierValue as any));
      req.setCopyPendingOrders(this.fromBoolValue(addReq.copyPendingOrders as any));
      req.setCopyStopLoss(this.fromBoolValue(addReq.copyStopLoss as any));
      req.setCopyTakeProfit(this.fromBoolValue(addReq.copyTakeProfit as any));
      req.setReverseTrade(this.fromBoolValue(addReq.reverseTrade as any));
      req.setFixedLotValue(this.fromInt32Value(addReq.fixedLotValue as any));
      req.setLotMultiplierValue(this.fromInt32Value(addReq.lotMultiplierValue as any));
      req.setRiskType(addReq.riskType);
      req.setForceMinimumLotSize(this.fromBoolValue(addReq.forceMinimumLotSize as any));
      req.setForceMaximumLotSize(this.fromBoolValue(addReq.forceMaximumLotSize as any));
      req.setCopyComment(this.fromBoolValue(addReq.copyComment as any));
      req.setCustomComment(this.fromStringValue(addReq.customComment as any));
      req.setCustomPlacedType(this.fromStringValue(addReq.customPlacedType as any));
      req.setStrictClose(this.fromBoolValue(addReq.strictClose as any));
      req.setConsiderContractSize(this.fromBoolValue(addReq.considerContractSize as any));
      req.setCopyMagicNumber(this.fromBoolValue(addReq.copyMagicNumber as any));
      req.setMagicNumber(this.fromInt64Value(addReq.magicNumber as any));
      req.setFixedBalanceMultiplierValue(this.fromInt32Value(addReq.fixedBalanceMultiplierValue as any));
      req.setFixedMasterBalance(this.fromInt32Value(addReq.fixedMasterBalance as any));
      req.setLotRefinerValue(this.fromInt32Value(addReq.lotRefinerValue as any));
      req.setMinDelayTime(this.fromInt64Value(addReq.minDelayTime as any));
      req.setMaxDelayTime(this.fromInt64Value(addReq.maxDelayTime as any));
      req.setMagicFiltersList(this.fromInt64ValueArr(addReq.magicFiltersList));
      req.setCopyExpiryTime(this.fromBoolValue(addReq.copyExpiryTime as any));
      req.setCommentFiltersList(this.fromStringValueArr(addReq.commentFiltersList));
      req.setMinLotFilter(this.fromInt64Value(addReq.minLotFilter as any));
      req.setMaxLotFilter(this.fromInt64Value(addReq.maxLotFilter as any));
      req.setStopLossPip(this.fromDoubleValue(addReq.stopLossPip as any));
      req.setTakeProfitPip(this.fromDoubleValue(addReq.takeProfitPip as any));
      req.setSlRefiner(this.fromDoubleValue(addReq.slRefiner as any));
      req.setTpRefiner(this.fromDoubleValue(addReq.tpRefiner as any));
      req.setBalancePercentageValue(this.fromDoubleValue(addReq.balancePercentageValue as any));
      req.setAllowedTradeSide(this.fromStringValueNull(addReq.allowedTradeSide));
      req.setMagicFilterType(addReq.magicFilterType);
      req.setCommentFilterType(addReq.commentFilterType);

      const client = this.getClient();
      client.updateCopierTemplate(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  addCopierTemplate = (addReq: AddCopierTemplateReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new AddCopierTemplateReq();
      req.setUserId(addReq.userId);
      req.setName(addReq.name);
      req.setBalanceMultiplierValue(this.fromInt32Value(addReq.balanceMultiplierValue as any));
      req.setCopyPendingOrders(this.fromBoolValue(addReq.copyPendingOrders as any));
      req.setCopyStopLoss(this.fromBoolValue(addReq.copyStopLoss as any));
      req.setCopyTakeProfit(this.fromBoolValue(addReq.copyTakeProfit as any));
      req.setReverseTrade(this.fromBoolValue(addReq.reverseTrade as any));
      req.setFixedLotValue(this.fromInt32Value(addReq.fixedLotValue as any));
      req.setLotMultiplierValue(this.fromInt32Value(addReq.lotMultiplierValue as any));
      req.setRiskType(addReq.riskType);
      req.setForceMinimumLotSize(this.fromBoolValue(addReq.forceMinimumLotSize as any));
      req.setForceMaximumLotSize(this.fromBoolValue(addReq.forceMaximumLotSize as any));
      req.setCopyComment(this.fromBoolValue(addReq.copyComment as any));
      req.setCustomComment(this.fromStringValue(addReq.customComment as any));
      req.setCustomPlacedType(this.fromStringValue(addReq.customPlacedType as any));
      req.setStrictClose(this.fromBoolValue(addReq.strictClose as any));
      req.setConsiderContractSize(this.fromBoolValue(addReq.considerContractSize as any));
      req.setCopyMagicNumber(this.fromBoolValue(addReq.copyMagicNumber as any));
      req.setMagicNumber(this.fromInt64Value(addReq.magicNumber as any));
      req.setFixedBalanceMultiplierValue(this.fromInt32Value(addReq.fixedBalanceMultiplierValue as any));
      req.setFixedMasterBalance(this.fromInt32Value(addReq.fixedMasterBalance as any));
      req.setLotRefinerValue(this.fromInt32Value(addReq.lotRefinerValue as any));
      req.setMinDelayTime(this.fromInt64Value(addReq.minDelayTime as any));
      req.setMaxDelayTime(this.fromInt64Value(addReq.maxDelayTime as any));
      req.setMagicFiltersList(this.fromInt64ValueArr(addReq.magicFiltersList));
      req.setCopyExpiryTime(this.fromBoolValue(addReq.copyExpiryTime as any));
      req.setCommentFiltersList(this.fromStringValueArr(addReq.commentFiltersList));
      req.setMinLotFilter(this.fromInt64Value(addReq.minLotFilter as any));
      req.setMaxLotFilter(this.fromInt64Value(addReq.maxLotFilter as any));
      req.setStopLossPip(this.fromDoubleValue(addReq.stopLossPip as any));
      req.setTakeProfitPip(this.fromDoubleValue(addReq.takeProfitPip as any));
      req.setSlRefiner(this.fromDoubleValue(addReq.slRefiner as any));
      req.setTpRefiner(this.fromDoubleValue(addReq.tpRefiner as any));
      req.setBalancePercentageValue(this.fromDoubleValue(addReq.balancePercentageValue as any));
      req.setAllowedTradeSide(this.fromStringValueNull(addReq.allowedTradeSide));
      req.setMagicFilterType(addReq.magicFilterType);
      req.setCommentFilterType(addReq.commentFilterType);

      const client = this.getClient();
      client.addCopierTemplate(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  pauseAccount = (pauseReq: PauseAccountReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new PauseAccountReq();
      req.setUserId(pauseReq.userId);
      req.setConfigId(pauseReq.configId);
      if (!!pauseReq.slaveId?.value) {
        req.setSlaveId(this.fromStringValue(pauseReq.slaveId));
      }
      if (pauseReq.pauseUntil && pauseReq.pauseUntil.seconds > 0) {
        req.setPauseUntil(this.fromTimestamp(pauseReq.pauseUntil));
      }

      const client = this.getClient();
      client.pauseAccount(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  fromBoolValue = (s: BoolValue.AsObject | undefined): BoolValue => {
    if (s === null || s === undefined) {
      return null as any;
    }
    let boolValue = new BoolValue();
    boolValue.setValue(s?.value);
    return boolValue;
  };

  fromBoolArrayValue = (s: BoolValue.AsObject[] | undefined): BoolValue[] => {
    if (s === null || s === undefined) {
      return null as any;
    }

    let boolArray: BoolValue[] = [];
    for (const i of s) {
      let boolValue = new BoolValue();
      boolValue.setValue(i?.value);
      boolArray.push(boolValue);
    }

    return boolArray;
  };

  fromTimestamp = (s: Timestamp.AsObject | undefined): Timestamp => {
    if (s === null || s === undefined) {
      return null as any;
    }
    let timestamp = new Timestamp();
    timestamp.setNanos(s?.nanos);
    timestamp.setSeconds(s?.seconds);
    return timestamp;
  };

  fromStringValue = (s: StringValue.AsObject | undefined): StringValue => {
    if (s === null || s === undefined) {
      return null as any;
    }
    let stringValue = new StringValue();
    stringValue.setValue(s.value);
    return stringValue;
  };

  fromStringValueNull = (s: StringValue.AsObject | undefined): StringValue => {
    if (s === null || s === undefined || !s?.value) {
      return null as any;
    }
    let stringValue = new StringValue();
    stringValue.setValue(s.value);
    return stringValue;
  };

  fromTradingHourList = (s: TradingHour.AsObject[] | undefined): TradingHour[] => {
    if (s === null || s === undefined) {
      return null as any;
    }
    const tradingHourList: TradingHour[] = [];
    for (const i of s) {
      let tradingHour = new TradingHour();
      tradingHour.setDayOfWeek(i.dayOfWeek);
      tradingHour.setStartTime(i.startTime);
      tradingHour.setEndTime(i.endTime);
      // if (i.startTime) {
      //   const timestamp = new Timestamp();
      //   timestamp.setSeconds(i.startTime);
      //   timestamp.setNanos(i.startTime);
      //   tradingHour.setStartTime(timestamp);
      // }
      // if (i.endTime) {
      //   const timestamp = new Timestamp();
      //   timestamp.setSeconds(i.endTime.seconds);
      //   timestamp.setNanos(i.endTime.nanos);
      //   tradingHour.setEndTime(timestamp);
      // }
      tradingHourList.push(tradingHour);
    }
    return tradingHourList;
  };

  fromStringValueArr = (s: StringValue.AsObject[] | undefined): StringValue[] => {
    if (s === null || s === undefined) {
      return null as any;
    }
    const stringValArr: StringValue[] = s.map((val) => {
      let stringValue = new StringValue();
      stringValue.setValue(val.value);
      return stringValue;
    });

    return stringValArr;
  };

  fromInt64ValueArr = (s: Int64Value.AsObject[] | undefined): Int64Value[] => {
    if (s === null || s === undefined) {
      return null as any;
    }
    const intValArr: Int64Value[] = s.map((val) => {
      let intValue = new Int64Value();
      intValue.setValue(val.value);
      return intValue;
    });

    return intValArr;
  };

  fromInt32Value = (s: Int32Value.AsObject | undefined): Int32Value => {
    if (s === null || s === undefined) {
      return null as any;
    }
    let int32Value = new Int32Value();
    int32Value.setValue(s.value);
    return int32Value;
  };

  fromInt64Value = (s: Int64Value.AsObject | undefined): Int64Value => {
    if (s === null || s === undefined) {
      return null as any;
    }
    let int64Value = new Int64Value();
    int64Value.setValue(s.value);
    return int64Value;
  };

  fromMappingList = (reqList: MappingReq.AsObject[] | undefined): MappingReq[] => {
    const result = [];
    if (reqList === undefined || reqList === null) {
      return [];
    }
    for (const req of reqList) {
      const mappingReq = new MappingReq();
      mappingReq.setName(req.name);
      mappingReq.setMaster(req.master);
      result.push(mappingReq);
    }
    return result;
  };

  flattenUpdateSlaveReq = (
    updateSlaveReq: UpdateSlaveReq.AsObject,
    slaveAccount?: string,
    masterAccount?: string
  ): Record<string, string | number | boolean | null> => {
    const flatObject = {
      timestamp: new Date()?.toISOString(),
      configId: updateSlaveReq.configId,
      slaveId: updateSlaveReq.slaveId,
      enable: updateSlaveReq.enable?.value ?? null,
      riskType: risk_type_display_map[updateSlaveReq.riskType],
      fixedLotValue: updateSlaveReq.fixedLotValue?.value ? updateSlaveReq.fixedLotValue?.value : null,
      lotMultiplierValue: updateSlaveReq.lotMultiplierValue?.value ? updateSlaveReq.lotMultiplierValue?.value : null,
      balanceMultiplierValue: updateSlaveReq.balanceMultiplierValue?.value ? updateSlaveReq.balanceMultiplierValue?.value : null,
      balancePercentageValue: updateSlaveReq.balancePercentageValue?.value ? updateSlaveReq.balancePercentageValue?.value : null,
      fixedBalanceMultiplierValue: updateSlaveReq.fixedBalanceMultiplierValue?.value
        ? updateSlaveReq.fixedBalanceMultiplierValue?.value
        : null,
      fixedMasterBalance: updateSlaveReq.fixedMasterBalance?.value ? updateSlaveReq.fixedMasterBalance?.value : null,

      copyStopLoss: updateSlaveReq.copyStopLoss?.value ?? null,
      copyTakeProfit: updateSlaveReq.copyTakeProfit?.value ?? null,
      copyPendingOrders: updateSlaveReq.copyPendingOrders?.value ?? null,

      takeProfitPip: updateSlaveReq.takeProfitPip?.value ?? null,
      stopLossPip: updateSlaveReq.stopLossPip?.value ?? null,
      slRefiner: updateSlaveReq.slRefiner?.value ?? null,
      tpRefiner: updateSlaveReq.tpRefiner?.value ?? null,

      forceMinimumLotSize: updateSlaveReq.forceMinimumLotSize?.value ?? null,
      forceMaximumLotSize: updateSlaveReq.forceMaximumLotSize?.value ?? null,
      reverseTrade: updateSlaveReq.reverseTrade?.value ?? null,

      considerContractSize: updateSlaveReq.considerContractSize?.value ?? null,
      copyExpiryTime: updateSlaveReq.copyExpiryTime?.value ?? null,
      strictClose: updateSlaveReq.strictClose?.value ?? null,
      copyComment: updateSlaveReq.copyComment?.value ?? null,
      customComment: updateSlaveReq.customComment?.value ?? null,
      copyMagicNumber: updateSlaveReq.copyMagicNumber?.value ?? null,
      magicNumber: updateSlaveReq.magicNumber?.value ?? null,
      minDelayTime: updateSlaveReq.minDelayTime?.value ?? null,
      maxDelayTime: updateSlaveReq.maxDelayTime?.value ?? null,
      lotRefinerValue: updateSlaveReq.lotRefinerValue?.value ?? null,

      magicFiltersList: updateSlaveReq.magicFiltersList?.map((item) => item.value).join(',') ?? '',
      commentFiltersList: updateSlaveReq.commentFiltersList?.map((item) => item.value).join(',') ?? '',
      minLotFilter: updateSlaveReq.minLotFilter?.value ?? null,
      maxLotFilter: updateSlaveReq.maxLotFilter?.value ?? null,

      manageExisting: updateSlaveReq.manageExisting?.value ?? null
    };

    return Object.fromEntries(Object.entries(flatObject).filter(([_, v]) => v !== null && v !== undefined));
  };
}

export class BrokerClient {
  meta: grpc.Metadata.HeaderObject = {};

  constructor() {
    this.meta = {};
  }

  setMeta(key: string, value: string | string[]) {
    this.meta[key] = value;
  }

  getClient = () => {
    if (__brokerManagerClient != null) {
      return __brokerManagerClient;
    }
    __brokerManagerClient = new BrokerManagerClient(gatewayAddress);
    return __brokerManagerClient;
  };

  listBrokers = (listBrokerReq: ListBrokersReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new ListBrokersReq();
      req.setPlatform(listBrokerReq.platform);
      req.setPaginationCursor(listBrokerReq.paginationCursor);
      req.setQuery(listBrokerReq.query);

      const client = this.getClient();
      client.listBrokers(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  getBrokerInfo = (brokerInfoReq: GetBrokerInfoReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new GetBrokerInfoReq();
      req.setId(brokerInfoReq.id);

      const client = this.getClient();
      client.getBrokerInfo(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  getServerInfo = (serverInfoReq: GetServerInfoReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new GetServerInfoReq();
      req.setBrokerId(serverInfoReq.brokerId);
      req.setServerId(serverInfoReq.serverId);

      const client = this.getClient();
      client.getServerInfo(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };
}

export class BillingClient {
  meta: grpc.Metadata.HeaderObject = {};

  constructor() {
    this.meta = {};
  }

  setMeta(key: string, value: string | string[]) {
    this.meta[key] = value;
  }

  getClient = () => {
    if (__billingClient != null) {
      return __billingClient;
    }
    __billingClient = new BillingManagerClient(gatewayAddress);
    return __billingClient;
  };

  createSubscription = (createSubReq: CreateSubscriptionReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new CreateSubscriptionReq();
      req.setUserId(createSubReq.userId);
      req.setPriceId(createSubReq.priceId);
      req.setQuantity(createSubReq.quantity);
      req.setToltReferral(createSubReq.toltReferral);
      req.setIsDedi(createSubReq.isDedi);

      const client = this.getClient();
      client.createSubscription(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  createCryptoPayment = (createSubReq: CreateCryptoPaymentRequest.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new CreateCryptoPaymentRequest();
      req.setUserId(createSubReq.userId);
      req.setCreateSubscription(this.fromCreateSubscription(createSubReq.createSubscription));
      req.setModifySubscription(this.fromModiySubscription(createSubReq.modifySubscription));
      req.setPurchaseTotal(createSubReq.purchaseTotal);
      req.setCreditPurchaseTotal(createSubReq.creditPurchaseTotal);

      const client = this.getClient();
      client.createCryptoPayment(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  getOverDueInfo = (createSubReq: GetOverDueInfoReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new GetOverDueInfoReq();
      req.setUserId(createSubReq.userId);
      req.setSubscriptionId(createSubReq.subscriptionId);

      const client = this.getClient();
      client.getOverDueInfo(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  renewOverDueSubscription = (createSubReq: RenewOverDueSubscriptionReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new RenewOverDueSubscriptionReq();
      req.setUserId(createSubReq.userId);
      req.setPaymentMethodId(createSubReq.paymentMethodId);
      req.setInvoiceId(createSubReq.invoiceId);

      const client = this.getClient();
      client.renewOverDueSubscription(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  listSubscriptions = (listSubscriptionsReq: ListSubscriptionsReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new ListSubscriptionsReq();
      req.setUserId(listSubscriptionsReq.userId);
      req.setStatusList(listSubscriptionsReq.statusList);

      const client = this.getClient();
      client.listSubscriptions(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  modifySubscriptions = (modifySubscriptionsReq: ModifySubscriptionReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new ModifySubscriptionReq();
      req.setUserId(modifySubscriptionsReq.userId);
      req.setSubscriptionId(modifySubscriptionsReq.subscriptionId);
      req.setQuantity(modifySubscriptionsReq.quantity);

      const client = this.getClient();
      client.modifySubscription(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  cancelSubscription = (cancelReq: CancelSubscriptionReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new CancelSubscriptionReq();
      req.setUserId(cancelReq.userId);
      req.setSubscriptionId(cancelReq.subscriptionId);

      const client = this.getClient();
      client.cancelSubscription(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  cancelSubscriptionImmediately = (cancelReq: CancelSubscriptionImmediatelyReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new CancelSubscriptionImmediatelyReq();
      req.setUserId(cancelReq.userId);
      req.setSubscriptionId(cancelReq.subscriptionId);

      const client = this.getClient();
      client.cancelSubscriptionImmediately(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  resumeSubscription = (resumeReq: ReactivateSubscriptionReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new ReactivateSubscriptionReq();
      req.setUserId(resumeReq.userId);
      req.setSubscriptionId(resumeReq.subscriptionId);

      const client = this.getClient();
      client.reactivateSubscription(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  listCards = (listCardReq: ListCardsReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new ListCardsReq();
      req.setUserId(listCardReq.userId);

      const client = this.getClient();
      client.listCards(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  setDefaultPaymentMethod = (defaultCardReq: SetDefaultPaymentMethodReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new SetDefaultPaymentMethodReq();
      req.setUserId(defaultCardReq.userId);
      req.setCardId(defaultCardReq.cardId);

      const client = this.getClient();
      client.setDefaultPaymentMethod(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  listInvoices = (invoiceReq: ListInvoicesReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new ListInvoicesReq();
      req.setUserId(invoiceReq.userId);
      // req.setInterval(invoiceReq.interval);
      req.setPageSize(invoiceReq.pageSize);
      req.setPaginationCursor(invoiceReq.paginationCursor);

      const client = this.getClient();
      client.listInvoices(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  getDownloadableInvoice = (invoiceReq: GetDownloadableInvoiceReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new GetDownloadableInvoiceReq();
      req.setUserId(invoiceReq.userId);
      req.setInvoiceId(invoiceReq.invoiceId);

      const client = this.getClient();
      client.getDownloadableInvoice(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  billingOverview = (invoiceReq: BillingOverviewReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new BillingOverviewReq();
      req.setUserId(invoiceReq.userId);

      const client = this.getClient();
      client.billingOverview(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  getUpcomingInvoice = (invoiceReq: GetUpcomingInvoiceReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new GetUpcomingInvoiceReq();
      req.setUserId(invoiceReq.userId);
      req.setQuantity(invoiceReq.quantity);
      req.setPriceId(invoiceReq.priceId);
      req.setInvoiceType(invoiceReq.invoiceType);
      req.setSubscriptionId(invoiceReq.subscriptionId);
      req.setCoupon(invoiceReq.coupon);

      const client = this.getClient();
      client.getUpcomingInvoice(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  listPrices = (pricesReq: ListPricesReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new ListPricesReq();
      req.setUserId(pricesReq.userId);

      const client = this.getClient();
      client.listPrices(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  cardSetUpIntent = (invoiceReq: CardSetUpIntentReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new CardSetUpIntentReq();
      req.setUserId(invoiceReq.userId);

      const client = this.getClient();
      client.cardSetUpIntent(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  deleteCard = (deleteReq: DeleteCardReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new DeleteCardReq();
      req.setUserId(deleteReq.userId);
      req.setCardId(deleteReq.cardId);

      const client = this.getClient();
      client.deleteCard(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  fromModiySubscription = (req: ModifySubscriptionReq.AsObject | undefined): ModifySubscriptionReq => {
    if (req === undefined || req === null) {
      return null as any;
    }
    const modifyReq = new ModifySubscriptionReq();
    modifyReq.setUserId(req.userId);
    modifyReq.setQuantity(req.quantity);
    modifyReq.setSubscriptionId(req.subscriptionId);
    return modifyReq;
  };

  fromCreateSubscription = (req: CreateSubscriptionReq.AsObject | undefined): CreateSubscriptionReq => {
    if (req === undefined || req === null) {
      return null as any;
    }
    const createReq = new CreateSubscriptionReq();
    createReq.setUserId(req.userId);
    createReq.setQuantity(req.quantity);
    createReq.setIsDedi(req.isDedi);
    createReq.setToltReferral(req.toltReferral);
    createReq.setPriceId(req.priceId);
    return createReq;
  };
}

export class AnalyticsClient {
  meta: grpc.Metadata.HeaderObject = {};

  constructor() {
    this.meta = {};
  }

  setMeta(key: string, value: string | string[]) {
    this.meta[key] = value;
  }

  getClient = () => {
    if (__analyticsManagerClient != null) {
      return __analyticsManagerClient;
    }
    __analyticsManagerClient = new AnalyticsManagerClient(gatewayAddress);
    return __analyticsManagerClient;
  };

  listTrades = (listTradesReq: ListTradesReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new ListTradesReq();
      req.setAccountId(listTradesReq.accountId);
      req.setUserId(listTradesReq.userId);
      req.setPaginationCursor(listTradesReq.paginationCursor);
      req.setPageSize(listTradesReq.pageSize);
      req.setStatus(listTradesReq.status);
      req.setSearchKey(listTradesReq.searchKey);

      const client = this.getClient();
      client.listTrades(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  overviewStats = (overviewStatsReq: OverviewStatsReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new OverviewStatsReq();
      req.setUserId(overviewStatsReq.userId);
      req.setCurrency(overviewStatsReq.currency);

      const client = this.getClient();
      client.overviewStats(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  listAccountStats = (listAccountReq: ListAccountStatsReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new ListAccountStatsReq();
      req.setUserId(listAccountReq.userId);
      req.setAccountIdsList(listAccountReq.accountIdsList);

      const client = this.getClient();
      client.listAccountStats(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  accountStats = (accountStatsReq: AccountStatsReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new AccountStatsReq();
      req.setUserId(accountStatsReq.userId);
      req.setAccountId(accountStatsReq.accountId);

      const client = this.getClient();
      client.accountStats(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  copierMetrics = (copierMatricsReq: CopierMetricsReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new CopierMetricsReq();
      req.setUserId(copierMatricsReq.userId);
      req.setCurrency(copierMatricsReq.currency);

      const client = this.getClient();
      client.copierMetrics(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  getBalanceInfo = (balanceInfoReq: GetBalanceInfoReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new GetBalanceInfoReq();
      req.setUserId(balanceInfoReq.userId);
      req.setAccountsList(balanceInfoReq.accountsList);

      const client = this.getClient();
      client.getBalanceInfo(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  accountsOverviewStats = (accountsOverviewStatsReq: AccountsOverviewStatsReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new AccountsOverviewStatsReq();
      req.setUserId(accountsOverviewStatsReq.userId);
      req.setCurrency(accountsOverviewStatsReq.currency);

      const client = this.getClient();
      client.accountsOverviewStats(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };
}

export class NewsClient {
  meta: grpc.Metadata.HeaderObject = {};

  constructor() {
    this.meta = {};
  }

  setMeta(key: string, value: string | string[]) {
    this.meta[key] = value;
  }

  getClient = () => {
    if (__newsManagerClient != null) {
      return __newsManagerClient;
    }
    __newsManagerClient = new NewsManagerClient(gatewayAddress);
    return __newsManagerClient;
  };

  getCalendarEventList = (calendarEventsReq: CalendarEventListReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new CalendarEventListReq();
      req.setUserId(calendarEventsReq.userId);
      req.setRegion(calendarEventsReq.region);
      req.setImpact(calendarEventsReq.impact);
      req.setFromDate(calendarEventsReq.fromDate);
      req.setToDate(calendarEventsReq.toDate);
      req.setQuery(calendarEventsReq.query);
      req.setPage(calendarEventsReq.page);
      req.setPageSize(calendarEventsReq.pageSize);

      const client = this.getClient();
      client.getCalendarEventList(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  getMarketNewsList = (newsReq: MarketNewsListReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new MarketNewsListReq();
      req.setUserId(newsReq.userId);
      req.setQuery(newsReq.query);
      req.setSourcesList(newsReq.sourcesList);
      req.setCountriesList(newsReq.countriesList);
      req.setImpact(newsReq.impact);
      req.setSentiment(newsReq.sentiment);
      req.setAssetClassesList(newsReq.assetClassesList);
      req.setBookmarkedOnly(newsReq.bookmarkedOnly);
      req.setFromDate(newsReq.fromDate);
      req.setToDate(newsReq.toDate);
      req.setPage(newsReq.page);
      req.setPageSize(newsReq.pageSize);
      req.setSortBy(newsReq.sortBy);
      const client = this.getClient();
      client.getMarketNewsList(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  toggleNewsBookmark = (reqObj: ToggleNewsBookmarkReq) => {
    return new Promise<ToggleNewsBookmarkReply.AsObject>((resolve, reject) => {
      const client = this.getClient();
      client.toggleNewsBookmark(reqObj, this.meta as any, (err, resp) => {
        if (err) {
          reject(err);
        } else {
          resolve(resp!.toObject());
        }
      });
    });
  };

  listMyAlerts = (alertsReq: ListMyAlertsReq.AsObject) => {
    return new Promise<ListMyAlertsReply.AsObject>((resolve, reject) => {
      let req = new ListMyAlertsReq();
      req.setUserId(alertsReq.userId);
      req.setOnlyUnmuted(alertsReq.onlyUnmuted);
      req.setPage(alertsReq.page);
      req.setPageSize(alertsReq.pageSize);

      const client = this.getClient();
      client.listMyAlerts(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          resolve(resp!.toObject());
        }
      });
    });
  };

  createCalendarEventAlert = (alertReq: CreateCalendarEventAlertReq.AsObject) => {
    return new Promise<CreateCalendarEventAlertReply.AsObject>((resolve, reject) => {
      let req = new CreateCalendarEventAlertReq();
      req.setUserId(alertReq.userId);
      req.setCountry(alertReq.country);
      req.setEventName(alertReq.eventName);

      const client = this.getClient();
      client.createCalendarEventAlert(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          resolve(resp!.toObject());
        }
      });
    });
  };

  deleteCalendarEventAlert = (reqObj: DeleteCalendarEventAlertReq.AsObject) => {
    return new Promise<DeleteCalendarEventAlertReply.AsObject>((resolve, reject) => {
      let req = new DeleteCalendarEventAlertReq();
      req.setUserId(reqObj.userId);
      req.setAlertId(reqObj.alertId);

      const client = this.getClient();
      client.deleteCalendarEventAlert(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          resolve(resp!.toObject());
        }
      });
    });
  };
}

export class NotificationClient {
  meta: grpc.Metadata.HeaderObject = {};

  constructor() {
    this.meta = {};
  }

  setMeta(key: string, value: string | string[]) {
    this.meta[key] = value;
  }

  getClient = () => {
    if (__notificationClient != null) {
      return __notificationClient;
    }
    __notificationClient = new NotificationManagerClient(gatewayAddress);
    return __notificationClient;
  };

  getNotifications = (configReq: GetNotificationsReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new GetNotificationsReq();
      req.setUserId(configReq.userId);
      req.setType(configReq.type);

      const client = this.getClient();
      client.getNotifications(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  getNotification = (configReq: GetNotificationReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new GetNotificationReq();
      req.setEvent(configReq.event);
      req.setType(configReq.type);
      req.setUserId(configReq.userId);

      const client = this.getClient();
      client.getNotification(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  getConfigDetails = (configReq: ConfigDetailsReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new ConfigDetailsReq();
      req.setUserId(configReq.userId);
      req.setNotificationId(configReq.notificationId);
      req.setEventType(configReq.eventType);

      const client = this.getClient();
      client.getConfigDetails(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  overrideNotification = (configReq: OverrideNotificationReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new OverrideNotificationReq();
      req.setEvent(configReq.event);
      req.setType(configReq.type);
      req.setUserId(configReq.userId);
      req.setAccountId(configReq.accountId);
      req.setSubject(configReq.subject);
      req.setMessageTemplate(configReq.messageTemplate);
      req.setParentRevision(configReq.parentRevision);

      const client = this.getClient();
      client.overrideNotification(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  enableNotification = (configReq: EnableNotificationReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new EnableNotificationReq();
      req.setEvent(configReq.event);
      req.setType(configReq.type);
      req.setUserId(configReq.userId);
      req.setAccountId(configReq.accountId);

      const client = this.getClient();
      client.enableNotification(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  disableNotification = (configReq: DisableNotificationReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new DisableNotificationReq();
      req.setEvent(configReq.event);
      req.setType(configReq.type);
      req.setUserId(configReq.userId);

      const client = this.getClient();
      client.disableNotification(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  blockAccount = (blockReq: BlockNotificationReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new BlockNotificationReq();
      req.setUserId(blockReq.userId);
      req.setEvent(blockReq.event);
      req.setAccountId(blockReq.accountId);

      const client = this.getClient();
      client.blockAccount(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  unblockAccount = (unblockReq: UnblockNotificationReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new UnblockNotificationReq();
      req.setUserId(unblockReq.userId);
      req.setEvent(unblockReq.event);
      req.setAccountId(unblockReq.accountId);

      const client = this.getClient();
      client.unblockAccount(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  editConfig = (editReq: EditConfigReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new EditConfigReq();
      req.setUserId(editReq.userId);

      // Set notification config
      if (editReq.notificationConfig) {
        const config = new NotificationConfig();
        config.setUserId(editReq.notificationConfig.userId);
        config.setEventType(editReq.notificationConfig.eventType);
        config.setSubject(editReq.notificationConfig.subject);
        config.setNotificationType(editReq.notificationConfig.notificationType);
        config.setNotificationConfigId(editReq.notificationConfig.notificationConfigId);
        config.setMessageTemplate(editReq.notificationConfig.messageTemplate);
        config.setUserConfig(editReq.notificationConfig.userConfig);
        config.setEnabled(editReq.notificationConfig.enabled);
        req.setNotificationConfig(config);
      }

      // Set block list
      if (editReq.blockListList) {
        for (const acc of editReq.blockListList) {
          const meta = new AccountMeta();
          meta.setAccountId(acc.accountId);
          meta.setAccountName(acc.accountName);
          meta.setAccountConfigId(acc.accountConfigId);
          req.addBlockList(meta);
        }
      }

      // Set unblock list
      if (editReq.unblockListList) {
        for (const acc of editReq.unblockListList) {
          const meta = new AccountMeta();
          meta.setAccountId(acc.accountId);
          meta.setAccountName(acc.accountName);
          meta.setAccountConfigId(acc.accountConfigId);
          req.addUnblockList(meta);
        }
      }

      const client = this.getClient();
      client.editConfig(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  getIntegrationStatus = (integrationReq: IntegrationStatusReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new IntegrationStatusReq();
      req.setUserId(integrationReq.userId);
      // req.setDefaultEmail(configReq.defaultEmail);

      const client = this.getClient();
      client.getIntegrationStatus(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  installIntegration = (installReq: InstallIntegrationReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new InstallIntegrationReq();
      req.setUserId(installReq.userId);
      req.setType(installReq.type);

      const client = this.getClient();
      client.installIntegration(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  fromNotificationConfig = (req: NotificationConfig.AsObject | undefined): NotificationConfig => {
    if (req === undefined || req === null) {
      return null as any;
    }
    const notificationConfig = new NotificationConfig();
    notificationConfig.setUserId(req.userId);
    notificationConfig.setEnabled(req.enabled);
    notificationConfig.setUserConfig(req.userConfig);
    notificationConfig.setNotificationConfigId(req.notificationConfigId);
    notificationConfig.setNotificationType(req.notificationType);
    notificationConfig.setEventType(req.eventType);
    notificationConfig.setMessageTemplate(req.messageTemplate);
    notificationConfig.setSubject(req.subject);
    return notificationConfig;
  };

  fromAccountMeta = (reqList: AccountMeta.AsObject[] | undefined): AccountMeta[] => {
    const result: AccountMeta[] = [];
    if (reqList === undefined || reqList === null) {
      return null as any;
    }

    for (const req of reqList) {
      const accountMeta = new AccountMeta();
      accountMeta.setAccountId(req.accountId);
      accountMeta.setAccountConfigId(req.accountConfigId);
      accountMeta.setAccountName(req.accountName);
      result.push(accountMeta);
    }

    return result;
  };
}

export class StatusClient {
  meta: grpc.Metadata.HeaderObject = {};

  constructor() {
    this.meta = {};
  }

  setMeta(key: string, value: string | string[]) {
    this.meta[key] = value;
  }

  getClient = () => {
    if (__statusManagerClient != null) {
      return __statusManagerClient;
    }
    __statusManagerClient = new StatusManagerClient(gatewayAddress);
    return __statusManagerClient;
  };

  getStatus = () => {
    return new Promise((resolve, reject) => {
      let req = new StatusReq();

      const client = this.getClient();
      client.getStatus(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };
}

export class SentimentClient {
  meta: grpc.Metadata.HeaderObject = {};

  constructor() {
    this.meta = {};
  }
  setMeta(key: string, value: string | string[]) {
    this.meta[key] = value;
  }
  getClient = () => {
    if (__sentimentClient != null) {
      return __sentimentClient;
    }
    __sentimentClient = new SentimentAnalyzerClient(gatewayAddress);
    return __sentimentClient;
  };

  getSymbolsSentiment = (sentimentReq: GetSymbolsSentimentReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new GetSymbolsSentimentReq();
      req.setUserId(sentimentReq.userId);
      req.setQuery(sentimentReq.query);
      req.setPageSize(sentimentReq.pageSize);
      req.setPaginationCursor(sentimentReq.paginationCursor);
      req.setSentimentTrendFilter(sentimentReq.sentimentTrendFilter);
      const client = this.getClient();
      client.getSymbolsSentiment(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  getBrokersSymbolSentiment = (brokerReq: GetBrokersSymbolSentimentReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new GetBrokersSymbolSentimentReq();
      req.setUserId(brokerReq.userId);
      req.setSymbol(brokerReq.symbol);
      req.setPageSize(brokerReq.pageSize);
      req.setPaginationCursor(brokerReq.paginationCursor);
      const client = this.getClient();
      client.getBrokersSymbolSentiment(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  getSymbols = (symbolsReq: GetSymbolsReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new GetSymbolsReq();
      req.setUserId(symbolsReq.userId);
      req.setFilter(symbolsReq.filter);
      const client = this.getClient();
      client.getSymbols(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };
  sentimentOverview = (overviewReq: SentimentOverviewReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new SentimentOverviewReq();
      req.setUserId(overviewReq.userId);

      const client = this.getClient();

      client.sentimentOverview(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };
}

export class AnalyzerServiceClient {
  meta: grpc.Metadata.HeaderObject = {};
  constructor() {
    this.meta = {};
  }
  setMeta(key: string, value: string | string[]) {
    this.meta[key] = value;
  }
  getClient = () => {
    if (__analyzerClient != null) {
      return __analyzerClient;
    }
    __analyzerClient = new AnalyzerClient(gatewayAddress);
    return __analyzerClient;
  };

  getAccountTradeList = (tradeReq: GetAccountTradeListRequest.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new GetAccountTradeListRequest();
      req.setUserId(tradeReq.userId);
      req.setAccountId(tradeReq.accountId);
      req.setLimit(tradeReq.limit);
      req.setSortBy(tradeReq.sortBy);
      req.setSortDesc(tradeReq.sortDesc);

      if (tradeReq.page) {
        req.setPage(tradeReq.page);
      }

      if (tradeReq.search) {
        req.setSearch(tradeReq.search);
      }

      if (tradeReq.dateRange) {
        const dateRange = new DateRange();

        if (tradeReq.dateRange.startDate) {
          const startTimestamp = new Timestamp();
          startTimestamp.setSeconds(tradeReq.dateRange.startDate.seconds);
          startTimestamp.setNanos(tradeReq.dateRange.startDate.nanos);
          dateRange.setStartDate(startTimestamp);
        }

        if (tradeReq.dateRange.endDate) {
          const endTimestamp = new Timestamp();
          endTimestamp.setSeconds(tradeReq.dateRange.endDate.seconds);
          endTimestamp.setNanos(tradeReq.dateRange.endDate.nanos);
          dateRange.setEndDate(endTimestamp);
        }

        if (tradeReq.dateRange.days) {
          dateRange.setDays(tradeReq.dateRange.days);
        }

        req.setDateRange(dateRange);
      }

      const client = this.getClient();
      client.getAccountTradeList(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  listAccounts = (accountReq: ListAccountsReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new ListAccountsReq();
      req.setUserId(accountReq.userId);
      if (accountReq.accountType) req.setAccountType(accountReq.accountType);
      if (accountReq.sortBy) req.setSortBy(accountReq.sortBy);
      if (accountReq.sortOrder) req.setSortOrder(accountReq.sortOrder);
      if (accountReq.page) req.setPage(accountReq.page);
      if (accountReq.pageSize) req.setPageSize(accountReq.pageSize);
      if (accountReq.searchQuery) req.setSearchQuery(accountReq.searchQuery);

      const client = this.getClient();
      client.listAccounts(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  listAccountsLite = (accountReq: ListAccountsLiteReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new ListAccountsLiteReq();
      req.setUserId(accountReq.userId);
      if (accountReq.accountType) req.setAccountType(accountReq.accountType);

      const client = this.getClient();
      client.listAccountsLite(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  getPerformanceOverview = (perfReq: GetPerformanceOverviewReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new GetPerformanceOverviewReq();
      req.setUserId(perfReq.userId);
      req.setAccountId(perfReq.accountId);
      if (perfReq.currency) req.setCurrency(perfReq.currency);

      if (perfReq.dateRange) {
        const dateRange = new DateRange();

        if (perfReq.dateRange.startDate) {
          const startTimestamp = new Timestamp();
          startTimestamp.setSeconds(perfReq.dateRange.startDate.seconds);
          startTimestamp.setNanos(perfReq.dateRange.startDate.nanos);
          dateRange.setStartDate(startTimestamp);
        }

        if (perfReq.dateRange.endDate) {
          const endTimestamp = new Timestamp();
          endTimestamp.setSeconds(perfReq.dateRange.endDate.seconds);
          endTimestamp.setNanos(perfReq.dateRange.endDate.nanos);
          dateRange.setEndDate(endTimestamp);
        }

        if (perfReq.dateRange.days) {
          dateRange.setDays(perfReq.dateRange.days);
        }

        req.setDateRange(dateRange);
      }

      const client = this.getClient();
      client.getPerformanceOverview(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  getAccountPerformance = (reqObj: GetAccountPerformanceRequest.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new GetAccountPerformanceRequest();
      req.setUserId(reqObj.userId);
      req.setAccountId(reqObj.accountId);
      if (reqObj.currency) req.setCurrency(reqObj.currency);

      if (reqObj.dateRange) {
        const dateRange = new DateRange();

        if (reqObj.dateRange.startDate) {
          const startTimestamp = new Timestamp();
          startTimestamp.setSeconds(reqObj.dateRange.startDate.seconds);
          startTimestamp.setNanos(reqObj.dateRange.startDate.nanos);
          dateRange.setStartDate(startTimestamp);
        }

        if (reqObj.dateRange.endDate) {
          const endTimestamp = new Timestamp();
          endTimestamp.setSeconds(reqObj.dateRange.endDate.seconds);
          endTimestamp.setNanos(reqObj.dateRange.endDate.nanos);
          dateRange.setEndDate(endTimestamp);
        }

        if (reqObj.dateRange.days) {
          dateRange.setDays(reqObj.dateRange.days);
        }

        req.setDateRange(dateRange);
      }

      const client = this.getClient();
      client.getAccountPerformance(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  getPortfolioOverview = (reqObj: GetPortfolioOverviewReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new GetPortfolioOverviewReq();
      req.setUserId(reqObj.userId);
      if (reqObj.currency) req.setCurrency(reqObj.currency);

      const client = this.getClient();
      client.getPortfolioOverview(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  getPortfolioEquityCurve = (reqObj: GetPortfolioEquityCurveReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new GetPortfolioEquityCurveReq();
      req.setUserId(reqObj.userId);
      if (reqObj.currency) req.setCurrency(reqObj.currency);

      if (reqObj.dateRange) {
        const dateRange = new DateRange();
        if (reqObj.dateRange.startDate) {
          const startTs = new Timestamp();
          startTs.setSeconds(reqObj.dateRange.startDate.seconds);
          startTs.setNanos(reqObj.dateRange.startDate.nanos);
          dateRange.setStartDate(startTs);
        }
        if (reqObj.dateRange.endDate) {
          const endTs = new Timestamp();
          endTs.setSeconds(reqObj.dateRange.endDate.seconds);
          endTs.setNanos(reqObj.dateRange.endDate.nanos);
          dateRange.setEndDate(endTs);
        }
        if (reqObj.dateRange.days) {
          dateRange.setDays(reqObj.dateRange.days);
        }
        req.setDateRange(dateRange);
      }

      const client = this.getClient();
      client.getPortfolioEquityCurve(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  getPortfolioDailyAndCumulativeROI = (reqObj: GetPortfolioDailyAndCumulativeROIReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new GetPortfolioDailyAndCumulativeROIReq();
      req.setUserId(reqObj.userId);

      if (reqObj.dateRange) {
        const dateRange = new DateRange();
        if (reqObj.dateRange.startDate) {
          const startTs = new Timestamp();
          startTs.setSeconds(reqObj.dateRange.startDate.seconds);
          startTs.setNanos(reqObj.dateRange.startDate.nanos);
          dateRange.setStartDate(startTs);
        }
        if (reqObj.dateRange.endDate) {
          const endTs = new Timestamp();
          endTs.setSeconds(reqObj.dateRange.endDate.seconds);
          endTs.setNanos(reqObj.dateRange.endDate.nanos);
          dateRange.setEndDate(endTs);
        }
        if (reqObj.dateRange.days) {
          dateRange.setDays(reqObj.dateRange.days);
        }
        req.setDateRange(dateRange);
      }

      const client = this.getClient();
      client.getPortfolioDailyAndCumulativeROI(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  // Tag Management Methods
  getUserTags = (reqObj: GetUserTagsReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new GetUserTagsReq();
      req.setUserId(reqObj.userId);

      const client = this.getClient();
      client.getUserTags(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  createUserTag = (reqObj: CreateUserTagReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new CreateUserTagReq();
      req.setUserId(reqObj.userId);
      req.setName(reqObj.name);
      if (reqObj.color) req.setColor(reqObj.color);

      const client = this.getClient();
      client.createUserTag(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  deleteUserTag = (reqObj: DeleteUserTagReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new DeleteUserTagReq();
      req.setUserId(reqObj.userId);
      req.setTagId(reqObj.tagId);

      const client = this.getClient();
      client.deleteUserTag(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  setTradeTag = (reqObj: SetTradeTagReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new SetTradeTagReq();
      req.setUserId(reqObj.userId);
      req.setAccountId(reqObj.accountId);
      req.setTradeId(reqObj.tradeId);
      req.setTagId(reqObj.tagId);

      const client = this.getClient();
      client.setTradeTag(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };

  updateUserTag = (reqObj: UpdateUserTagReq.AsObject) => {
    return new Promise((resolve, reject) => {
      let req = new UpdateUserTagReq();
      req.setUserId(reqObj.userId);
      req.setTagId(reqObj.tagId);
      req.setName(reqObj.name);
      req.setColor(reqObj.color);

      const client = this.getClient();
      client.updateUserTag(req, this.meta as any, (err, resp) => {
        if (err != null) {
          reject(err);
        } else {
          let obj = resp?.toObject();
          resolve(obj);
        }
      });
    });
  };
}
